<template>
  <div class="analytics-page-content">
    <DashBoard :filters="filters"/>
    <Subscribe/>
  </div>
</template>

<script>
import DashBoard from "@/components/analytics/DashboardComponent.vue";
import Subscribe from "@/components/layouts/StayToUpdated.vue";

export default {
  name: 'AnalyticsContent',
  components: {
    Subscribe,
    DashBoard
  },
  data() {
    return {
      filters: {
        industry: '',
        period_month : '',
        period_year : '',
        geography: '',
        topic: '',
        query: '',
      }
    };
  },
  methods: {
    updateFilters(newFilters) {
      this.filters = {...this.filters, ...newFilters};
    },
  },
};
</script>
